<template>
  <el-card>
    <div slot="header" class="page-title">
      <div class="page-hedaer">
        <h4 class="page-title">使用教程</h4>
        <span class="title-info">(记得实操一下，然后退单)</span>
      </div>
    </div>
    <div class="tutorial-content">
      <el-row :gutter="20">
        <el-col :span="12" v-for="(step, index) in steps" :key="index">
          <div class="step-card">
            <div class="step-header">
              <div class="step-number">{{ index + 1 }}</div>
              <div>{{ step.title }}</div>
            </div>
            <div class="step-body">
              <div class="step-image">
                <el-image 
                  v-if="step.image" 
                  :src="step.image" 
                  fit="contain"
                  :preview-src-list="['/images/step1.jpg','/images/step2.jpg','/images/step3.jpg','/images/step4.jpg']"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div v-else class="image-placeholder">
                  <i class="el-icon-picture-outline"></i>
                  <span>图片区域</span>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>

<script>


export default {
  name: "Tutorial",
  data() {
    return {
      steps: [
        { title: "点击精选商品菜单，搜索商品，点击复制口令，然后粘贴到微信端",  image: "/images/step1.jpg" },
        { title: "打开手机微信，点击复制口令的链接，会打开小程序，点击购买，然后打开抖音会自动跳入商品页，点击商品进入直播间购买",  image: "/images/step2.jpg"  },
        { title: "打开抖音订单页，复制购买商品的订单号，复制到返利网站订单处认领即可",  image: "/images/step3.jpg" },
        { title: "注意事项3点",  image: "/images/step4.jpg" }
      ]
    };
  },
};
</script>

<style scoped>
.page-title{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.page-hedaer{
  display: flex;
  align-items: center;
  min-height: 32px;
}
.page-title{
  margin: 0;
}
.title-info{
  margin-left: 5px;
  font-size: 12px;
  color:#909399;
}
.tutorial-content {
  padding: 20px 0;
}
.step-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}
.step-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
}
.step-number {
  width: 28px;
  height: 28px;
  background: #409eff;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  flex-shrink: 0;
}
.step-header h3 {
  margin: 0;
  color: #303133;
}
.step-body {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.step-text p {
  margin: 0;
  color: #606266;
  line-height: 1.8;
}
.step-image {
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  border-radius: 8px;
  border: 2px dashed #dcdfe6;
}
.step-image .el-image {
  width: 100%;
  height: 300px;
}
.image-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #909399;
}
.image-placeholder i {
  font-size: 48px;
  margin-bottom: 10px;
}
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 200px;
  background: #f5f7fa;
  color: #909399;
  font-size: 48px;
}
</style>
